import Image from "next/image"

import { Box, HStack, Skeleton, SkeletonText, VStack } from "@chakra-ui/react"

export default function LoginSkeleton() {
    return (
        <Box maxWidth='md' width='full' px={8} mt={1}>
            <VStack spacing={6} align='stretch'>
                <Box mb={4}>
                    <Image
                        src={"/BLX-v2-logo.svg"}
                        alt='BrewLogix'
                        width={124}
                        height={24}
                        priority
                    />
                </Box>

                <VStack spacing={2} align='stretch'>
                    <Skeleton height='32px' width='224px' />
                    <Skeleton height='20px' width='256px' />
                </VStack>

                <VStack spacing={4} align='stretch'>
                    <VStack spacing={2} align='stretch'>
                        <Skeleton height='20px' width='80px' />
                        <Box position='relative'>
                            <Skeleton height='40px' rounded='lg' />
                        </Box>
                    </VStack>
                </VStack>

                <Skeleton height={10} startColor='green.800' endColor='green.400' rounded='lg' />

                <HStack justify='space-between' mt={4}>
                    <Skeleton height='16px' width='160px' />
                    <Skeleton height='16px' width='64px' />
                </HStack>

                <Box textAlign='center' mt={4}>
                    <SkeletonText
                        noOfLines={1}
                        spacing='4'
                        skeletonHeight='4'
                        width='256px'
                        margin='auto'
                    />
                </Box>
            </VStack>
        </Box>
    )
}
